var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "base-search-input-wrapper" } },
    [
      _c("input", {
        ref: "input",
        attrs: { "data-input": "search", placeholder: _vm.placeholder },
        domProps: { value: _vm.search },
        on: {
          input: _vm.onSearchChange,
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
                "Backspace",
                "Delete",
                "Del",
              ])
            ) {
              return null
            }
            return _vm.onDeleteKeydown.apply(null, arguments)
          },
        },
      }),
      _vm._v(" "),
      _vm.isOptionsPopupOpen
        ? _c("base-search-options-popup", {
            attrs: {
              query: _vm.query,
              schema: _vm.schema,
              trigger: _vm.inputRef,
              "is-open": true,
            },
            on: { "query-change": _vm.onQueryChange },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showDateTimePicker
        ? _c("base-search-date-time-popup", {
            attrs: {
              param: _vm.activeQueryParam,
              trigger: _vm.inputRef,
              "is-open": true,
            },
            on: {
              "param-change": _vm.onParamChange,
              close: _vm.onCloseDatepicker,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }